import { useQuery } from "react-query";
import scss from "./StaticPagesProfile.module.scss";
import ProfilePage from "pages/Profile/ProfilePage";
import { useNavigate, useParams } from "react-router-dom";
import useAPI from "hooks/useAPI";
import StaticPageContent from "components/StaticPageContent/StaticPageContent";
import LoadingWrapper from "components/Loading/LoadingWrapper";
import { useTranslation } from "react-i18next";
import { getOnboardingContent, startOnboardingTour } from "helpers/onboarding";

/** Slug of the portal manual (Sitemap.static.manual redirects here); it gets the "start the tour" box. */
const MANUAL_SLUG = "uputstvo";

/** CMS content can start the tour too, with a link to this anchor, e.g. <a href="#pokreni-vodic">. */
const START_TOUR_ANCHOR = "#pokreni-vodic";

const isPlaceholderContent = (content) => {
    if (!Array.isArray(content) || content.length === 0) return true;

    return content.every((item) => {
        if (item?.type !== "html_editor" && item?.type !== "textarea") return false;

        const text = String(item?.content ?? "")
            .replace(/<[^>]*>/g, " ")
            .replace(/&nbsp;/gi, " ")
            .replace(/\s+/g, " ")
            .trim()
            .replace(/[.!]+$/, "")
            .toLocaleLowerCase("sr-RS");

        return text === "stranica u izradi";
    });
};

const StaticPagesProfile = () => {
    const { slug } = useParams();
    const api = useAPI();
    const { data, isLoading } = useQuery([`StaticPagesProfile.${slug}`], () => api.get(`static-pages/content/${slug}`));
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const tour = getOnboardingContent(i18n.language).manualPage;

    const startTourFromContent = (event) => {
        if (!event.target.closest?.(`a[href$="${START_TOUR_ANCHOR}"]`)) return;
        event.preventDefault();
        startOnboardingTour(navigate);
    };

    return (
        <ProfilePage>
            <LoadingWrapper isLoading={isLoading}>
                {data && (
                    <div className={scss.page}>
                        <h4 className={scss.title}>{data?.basic_data?.name}</h4>
                        {slug === MANUAL_SLUG && (
                            <div className={scss.tour}>
                                <div>
                                    <p className={scss.tourTitle}>{tour.title}</p>
                                    <p className={scss.tourText}>{tour.text}</p>
                                </div>
                                <button type="button" className={scss.tourButton} onClick={() => startOnboardingTour(navigate)}>
                                    {tour.start}
                                </button>
                            </div>
                        )}
                        {isPlaceholderContent(data?.content) ? (
                            <div className={scss.placeholder} role="status">
                                <span className={scss.icon} aria-hidden="true">
                                    <svg viewBox="0 0 48 48" fill="none">
                                        <path d="M11 6.5h17l8 8V36a3 3 0 0 1-3 3H14a3 3 0 0 1-3-3V6.5Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
                                        <path d="M28 7v8h8M17 21h13M17 27h8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="m29 34 7.7-7.7a2.1 2.1 0 0 1 3 3L32 37l-4 1 1-4Z" fill="#f7f7f8" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <p>Stranica u izradi</p>
                            </div>
                        ) : (
                            <div className={scss.content} onClick={startTourFromContent}>
                                <StaticPageContent staticData={data.content} />
                            </div>
                        )}
                    </div>
                )}
            </LoadingWrapper>
        </ProfilePage>
    );
};

export default StaticPagesProfile;
